<template>
  <div>
    <!-- 视频播放 -->
    <div class="control">
      <div class="video-play">
        <template v-if="playVideoList.length > 0">
          <div
            class="video-box"
            v-for="(value, index) in playVideoList"
            ref="video_box"
            :key="value.id"
          >
            <tc-player-unit
              v-if="value.playStatus == true"
              :ref="'tcplayer' + index"
              :index="index"
              :playVideo="value"
              :widthHeigt="[100, 100]"
            ></tc-player-unit>
            <!-- <div class="no-play" v-else-if="value.playStatus == false">
              <img
                src="@/assets/img/schoolMonitorCenter/paperbroke.png"
                alt=""
              />
              <div class="tip">暂无接入信息</div>
            </div>
            <div v-else style="background:#000;width:400px;height:230px;text-align: center;line-height:230px;font-size:48px;color:#fff;">
              <el-icon class="el-icon-loading"></el-icon>
            </div> -->

            <div class="no-play" v-else-if="value.playStatus == false">
                <img
                  src="@/assets/img/schoolMonitorCenter/paperbroke.png"
                  alt=""
                />
                <div class="tip" :class="value.info?'noPlayErrorInfo':''">{{ value.info || '无监控播放'}}</div>
              </div>
              <div v-else style="background:#000;width:400px;height:230px;text-align: center;line-height:230px;font-size:48px;color:#fff;">
                <el-icon class="el-icon-loading"></el-icon>
              </div>
          </div>
        </template>
        <!-- 视频不够 4 个时显示 -->
        <template v-if="noPlayVideoList.length > 0">
          <div
            class="video-box no-play"
            v-for="(value, key) in noPlayVideoList"
            :key="key"
          >
            <img src="@/assets/img/schoolMonitorCenter/paperbroke.png" alt="" />
            <div class="tip">暂无接入信息</div>
          </div>
        </template>
      </div>
      <!-- <div class="control-sel" v-if="newArray.length > 0">
        <div class="name">实时监控</div>
        <div class="tip">视频轮播</div>
        <div class="sel">
          <div :class="{ active: isAutoplay }" @click="change(1)">开启</div>
          <div :class="{ active: !isAutoplay }" @click="change(2)">关闭</div>
        </div>
      </div> -->
    </div>
    <!-- 轮播 -->
    <div class="video-list" v-if="newArray.length > 0">
      <div class="block">
        <el-carousel
          trigger="click"
          height="116px"
          :autoplay="isAutoplay"
          :interval="intervalTime"
          indicator-position="none"
          arrow="always"
          @change="move"
        >
          <el-carousel-item
            class="carousel-item clearfix"
            v-for="(item, index) in newArray"
            :key="index"
          >
            <div
              class="video"
              v-for="(inner, index) in item"
              :key="index"
              @click="select(inner)"
            >
              <span class="video-address">{{ inner.monitorName }}</span>
              <span class="video-school">{{ schoolName }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="sel-btn">
        <div class="start" :class="{active : isAutoplay}" @click="isAutoplay = true"></div>
        <div class="stop" :class="{active : !isAutoplay}" @click="isAutoplay = false"></div>
      </div>
      <div class="sel-rate">
        <div class="fast" :class="{active : intervalTime == 10000}" @click="intervalTime = 10000"></div>
        <div class="middle" :class="{active : intervalTime == 30000}" @click="intervalTime = 30000"></div>
        <div class="slow" :class="{active : intervalTime == 60000}" @click="intervalTime = 600000"></div>
      </div>
    </div>
    <!-- 选择窗口播放弹窗 -->
    <el-dialog
      class="select-dailog"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="padding: 0"
    >
      <div class="content">
        <div class="select-close" @click="dialogVisible = false">关闭</div>
        <div class="content-title">
          <img src="@/assets/img/schoolMonitorCenter/select-video-seat-icon.png" alt="" />
          <span>选择视频播放窗口</span>
        </div>
        <div class="content-select">
          <div class="select-list">
            <div class="select-li" @click="selectVideoSeat(0)">窗口一</div>
            <div class="select-li" @click="selectVideoSeat(1)">窗口二</div>
          </div>
          <div class="select-list">
            <div class="select-li" @click="selectVideoSeat(2)">窗口三</div>
            <div class="select-li" @click="selectVideoSeat(3)">窗口四</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TcPlayerUnit from "./TcPlayerUnit";
export default {
  name: "videoPlayList",
  components: {
    TcPlayerUnit
  },
  props: {},
  data() {
    return {
      schoolName: "",
      playVideoList: [],
      noPlayVideoList: [],
      isAutoplay: true,
      intervalTime: 60000,
      newArray: [],
      selectVideo: {},
      dialogVisible: false
    };
  },
  created() {},
  mounted() {},
  computed: {
    eduSchoolInfo: {
      get() {
        return this.$store.state.eduSchoolInfo;
      },
      set() {}
    },
    eduSelectSchool() {
      return this.$store.state.eduSelectSchool;
    },
    eduSelectVideo() {
      return this.$store.state.eduSelectVideo;
    }
  },
  watch: {
    eduSchoolInfo: {
      handler(newVal, oldVal) {
        this.eduSchoolInfo = newVal;
        this.showVideoList();
        this.modify();
      },
      deep: true
    },
    eduSelectSchool() {
      if (
        this.eduSchoolInfo.list.length > 0 &&
        this.eduSchoolInfo.list[0].schoolId == this.eduSelectSchool.schoolId
      ) {
        return;
      } else {
        this.eduSchoolInfo.list[0] = this.eduSelectSchool;
        this.showVideoList();
        this.modify();
      }
    },
    eduSelectVideo() {
      this.select(this.eduSelectVideo);
    }
  },
  methods: {
    move(index,preIndex) {
      this.showVideoSwiper(this.newArray[index]);
    },
    
    decideVideoNum(playVideoList) {
      if (playVideoList.length > 3) {
          this.playVideoList = playVideoList;
        } else if (playVideoList.length == 3) {
          let arrTemp = [
            {
              playStatus: false,
              id: "video-" + 3
            }
          ];
          playVideoList = playVideoList.concat([], arrTemp);
          this.playVideoList = playVideoList;
        } else if (playVideoList.length == 2) {
          let arrTemp = [
            {
              playStatus: false,
              id: "video-" + 2
            },
            {
              playStatus: false,
              id: "video-" + 3
            }
          ];
          playVideoList = playVideoList.concat([], arrTemp);
          this.playVideoList = playVideoList;
        } else if (playVideoList.length == 1) {
          let arrTemp = [
            {
              playStatus: false,
              id: "video-" + 1
            },
            {
              playStatus: false,
              id: "video-" + 2
            },
            {
              playStatus: false,
              id: "video-" + 3
            }
          ];
          playVideoList = playVideoList.concat([], arrTemp);
          this.playVideoList = playVideoList;
        } else {
          this.showNoVideoList(0);
        }
    },
    // 展示播放的视频列表
    showVideoList() {
      if (
        this.eduSchoolInfo.list.length > 0 &&
        this.eduSchoolInfo.list[0].monitorsInfo.length > 0 &&
        this.eduSchoolInfo.list[0].monitorsInfo[0].monitor != ""
      ) {
        if (this.playVideoList.length > 0) {
          this.playVideoList = [];
        }
        this.showVideoSwiper(this.eduSchoolInfo.list[0].monitorsInfo)
        this.showNoVideoList(4);
      } else {
        this.playVideoList = [];
        this.showNoVideoList(0);
      }
    },

    async showVideoSwiper(array) {
      let videoList = array;
      console.log('showVideoSwiper',array)
      let newI = videoList.length <= 4 ? videoList.length : 4;
      let playVideoList = [];
      for (var i = 0; i < 4; i++) {
        if(videoList[i] && videoList[i].monitor.isPull == 0){
          playVideoList.push({
            playStatus: true,
            id: "video-" + i,
            m3u8_sd: videoList[i].monitor.hls,
            m3u8_hd: videoList[i].monitor.flv,
            flv_sd: videoList[i].monitor.flv,
            flv_hd: videoList[i].monitor.flvHd,
            videoAddress: videoList[i].monitorName
          });
        }else{
          if(videoList[i]){
            playVideoList.push({
              id: "video-" + i,
            });
          }else{
            playVideoList.push({
              playStatus: false,
              id: "video-" + i,
            });
          }
        }
      }
      this.playVideoList = playVideoList;
      for (var i = 0; i < newI; i++) {
        if(videoList[i].monitor.isPull != 0){
          let data = {
            code: videoList[i].monitor.playCode,
            streamType: 1,
            forceH264: false
          }
          this.getPlayUrls(data,i)
        }
      }
    },
    getPlayUrls(data,i){
      this.$playHttp.getPlayUrl(data).then(results =>{
        if(results.data.errno == 0){
          this.playVideoList.splice(i,1,{
            playStatus: true,
            id: "video-" + i,
            m3u8_hd: 'wss://vs.zzsasoft.com' + results.data.data.flv,
            videoAddress: results.data.data.name
          });
        }else{
          this.playVideoList.splice(i,1,{
            playStatus: false,
            id: "video-" + i,
            info: '摄像头未推流'
          });
        }
      })
    },
    // 显示没有视频时的信息
    showNoVideoList(newI) {
      // console.log(newI + '====newI')
      let noPlayVideoList = [];
      if (newI < 4) {
        var imgNum = 4 - newI;
        for (var i = 0; i < imgNum; i++) {
          noPlayVideoList.push(imgNum);
        }
      }
      this.noPlayVideoList = noPlayVideoList;
    },
    // 选择在哪个窗口播放视频
    async selectVideoSeat(seat) {
      this.playVideoList[seat] = {
        loading: true,
      }
      this.dialogVisible = false;
      let selVideo = {};
      // console.log(this.selectVideo)
      if(this.selectVideo.isPull == 0){
        selVideo = {
          loading: false,
          playStatus: true,
          id: "video-" + seat,
          videoUrl: this.selectVideo.videoUrl,
          m3u8_sd: this.selectVideo.m3u8_sd,
          m3u8_hd: this.selectVideo.m3u8_hd,
          flv_sd: this.selectVideo.flv_sd,
          flv_hd: this.selectVideo.flv_hd,
          videoAddress: this.selectVideo.monitorName
        }
        this.playVideoList.splice(seat,1,selVideo)
      }else{
        let data = {
          // id: this.selectVideo.playId,
          code: this.selectVideo.playCode,
          streamType: 1,
          forceH264: false
        }
        let results = await this.$playHttp.getPlayUrl(data);

        if(results.data.errno == 0){
          let selVideo = {}
          selVideo = {
            playStatus: true,
            id: "video-" + seat,
            m3u8_hd: 'wss://vs.zzsasoft.com' + results.data.data.flv,
            videoAddress: results.data.data.name
          }
          this.playVideoList.splice(seat,1,selVideo)
        }else{
          this.playVideoList.splice(seat,1,{
          // playVideoList.push({
            playStatus: false,
            id: "video-" + i,
            info: '摄像头未推流'
          });
          // this.$message.error('请检查摄像头网络')
        }
      }
      // console.log(this.playVideoList)
    },

    // 修改返回视频数组结构
    modify() {
      if (
        this.eduSchoolInfo.list.length > 0 &&
        this.eduSchoolInfo.list[0].monitorsInfo.length > 0 &&
        this.eduSchoolInfo.list[0].monitorsInfo[0].monitor != ""
      ) {
        let videoList = this.eduSchoolInfo.list[0].monitorsInfo;
        this.schoolName = this.eduSchoolInfo.list[0].schoolName;
        let newArray = [];
        let start = 0;
        let end = 4;
        let groupNum = 4;
        let length = videoList.length;
        let times = parseInt(length / groupNum);
        if (times * groupNum <= length) {
          times++;
        }
        for (var i = 0; i < times; i++) {
          let sliceArray = videoList.slice(start, end);
          start = end;
          end = end + groupNum;
          if (sliceArray.length > 0) {
            newArray.push(sliceArray);
          }
        }
        this.newArray = newArray;
      } else {
        this.newArray = [];
      }

      // console.log(newArray);
    },
    // 选择视频
    select(item) {
      // console.log(item);
      this.selectVideo = {
        playStatus: true,
        // id: "",
        
        isPull: item.monitor.isPull,
        playId: item.monitor.playId,
        playCode: item.monitor.playCode,
        videoUrl: item.monitor.hls,
        m3u8_sd: item.monitor.hls,
        m3u8_hd: item.monitor.flv,
        flv_sd: item.monitor.flv,
        flv_hd: item.monitor.flvHd,
        videoAddress: item.monitorName
      };
      this.dialogVisible = true;
    },
    // 是否开启轮播
    change(num) {
      if (num == 1) {
        this.isAutoplay = true;
      } else {
        this.isAutoplay = false;
      }
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.control {
  height: 610px;
  position: relative;
  .control-sel {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 187px;
    height: 185px;
    background: url("~@/assets/img/schoolMonitorCenter/control-sel-bg.png") center center no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -93.5px;
    margin-top: -92.5px;
    .name {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffd781;
      line-height: 25px;
      letter-spacing: 1px;
    }
    .tip {
      margin: 4px 0;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #c4cdff;
      line-height: 17px;
    }
    .sel {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 84px;
      height: 24px;
      box-shadow: 0px 1px 12px 0px #8b99ff inset;
      border-radius: 1px;
      div {
        width: 35px;
        height: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 18px;
        cursor: pointer;
        &.active {
          box-shadow: 0px 1px 12px 0px #8b99ff;
          border-radius: 1px;
        }
      }
    }
  }
  .video-play {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    background: url("~@/assets/img/schoolMonitorCenter/video-bg-1.png") center center no-repeat;
    background-size: 100% 100%;
    .video-box {
      width: 49.5%;
      height: 300px;
      padding: 10px 10px;
      margin-bottom: 10px;
      position: relative;
      &:nth-child(3),
      &:nth-child(4) {
        margin-bottom: 0;
      }
      &.no-play {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .tip {
          margin-top: 10px;
          color: #ffffff;
          font-size: 14px;
        }
      }
      .no-play {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .tip {
          margin-top: 10px;
          color: #ffffff;
          font-size: 14px;
        }
      }
      /deep/ .video {
        width: 100%;
        height: 100%;
        position: relative;
        video {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
      }
    }
  }
}
.video-list {
  margin-top: 4px;
  .el-carousel__arrow {
    background: transparent;
  }
  .carousel-item {
    display: flex;
    justify-content: center;
    align-items: center;
    .video {
      width: 140px;
      height: 108px;
      float: left;
      margin-right: 15px;
      cursor: pointer;
      background: url("~@/assets/img/schoolMonitorCenter/video-list-bg.png") center center no-repeat;
      background-size: 100% 100%;
      text-align: center;
      position: relative;
      &:last-child {
        margin-right: 0;
      }
    }
    .video-address {
      display: inline-block;
      width: 72px;
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #dbe1ff;
      line-height: 14px;
      text-align: center;
      overflow: hidden;
      word-break: break-all;
      text-overflow: ellipsis;
      white-space: nowrap;
      position: relative;
    }
    .video-school {
      display: inline-block;
      width: 140px;
      height: 26px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 26px;
      overflow: hidden;
      word-break: break-all;
      text-overflow: ellipsis;
      white-space: nowrap;
      background: rgba(0, 0, 0, 0.2);
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  .sel-btn {
    margin-top: 4px;
    width: 100%;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    .start {
      margin-right: 20px;
      width: 118px;
      height: 36px;
      background: url("~@/assets/img/eduBigData/swiper-start.png") center center no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &.active {
        background: url("~@/assets/img/eduBigData/swiper-start-active.png") center center no-repeat;
        background-size: 100% 100%;
      }
    }
    .stop {
      width: 118px;
      height: 36px;
      background: url("~@/assets/img/eduBigData/swiper-stop.png") center center no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &.active {
        background: url("~@/assets/img/eduBigData/swiper-stop-active.png") center center no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .sel-rate {
    margin-top: 4px;
    width: 100%;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    .fast {
      margin-right: 20px;
      width: 118px;
      height: 36px;
      background: url("~@/assets/img/eduBigData/fast.png") center center no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &.active {
        background: url("~@/assets/img/eduBigData/fast-active.png") center center no-repeat;
        background-size: 100% 100%;
      }
    }
    .middle {
      margin-right: 20px;
      width: 118px;
      height: 36px;
      background: url("~@/assets/img/eduBigData/middle.png") center center no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &.active {
        background: url("~@/assets/img/eduBigData/middle-active.png") center center no-repeat;
        background-size: 100% 100%;
      }
    }
    .slow {
      width: 118px;
      height: 36px;
      background: url("~@/assets/img/eduBigData/slow.png") center center no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &.active {
        background: url("~@/assets/img/eduBigData/slow-active.png") center center no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
.select-dailog {
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    padding: 0;
  }
  /deep/ .el-dialog {
    width: 450px;
    background: transparent;
  }
  /deep/ .el-dialog__body {
    width: 450px;
    background: transparent;
    padding: 0;
  }
  .content {
    padding-top: 12px;
    width: 450px;
    height: 320px;
    // 已修改
    background: url("~@/assets/img/hiddenDangerNow/hidden-detail-dialog-bg.png") center center no-repeat;
    background-size: 100% 100%;
    position: relative;
    .select-close {
      width: 56px;
      height: 24px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #d7deff;
      text-align: center;
      line-height: 25px;
      letter-spacing: 1px;
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
    }
    .content-title {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 22px;
      }
    }
    .content-select {
      margin-top: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      .select-list {
        display: flex;
        justify-content: center;
        align-items: center;
        .select-li {
          margin-bottom: 24px;
          margin-right: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 146px;
          height: 52px;
          box-shadow: 8px -5px 18px 0px #526ecc inset;
          border-radius: 1px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #c4f0ff;
          line-height: 22px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>
